import React from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from '../Icon';
import './Checkbox.scss';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface CheckboxProps {
  checked?: boolean;
  label?: string;
  id?: string;
  value?: any;
  containerStyle?: any;
  disabled?: any;
  colorful?: any;
  onChange?: any;
  [key: string]: any;
}

const Checkbox = ({
  checked,
  label,
  id,
  value,
  containerStyle = {},
  ...props
}: CheckboxProps) => (
  <label
    className="checkbox"
    style={{ ...containerStyle, cursor: props?.disabled && 'not-allowed' }}
  >
    {label}
    <input
      className="checkbox__control"
      type="checkbox"
      id={id}
      value={value}
      checked={checked}
      {...props}
    />
    <span
      className={classNames('checkmark', {
        'checkmark--checked': value,
        'checkmark--colorful': props?.colorful,
      })}
    >
      <FontAwesomeIcon glyph="check" weight="regular" />
    </span>
  </label>
);

export default Checkbox;